module.exports = __webpack_public_path__ + "static/assets/e00bbeaf03e273bbf4b3678b89994f2d.png";